export default [
  {
    _name: "CSidebarNav",
    _children: [
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Dashboard',
      //   to: '/dashboard',
      //   icon: 'cil-speedometer',
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Daily-Updates',
      //   to: '/dailyDashboard',
      //   icon: 'cil-speedometer',
      // },

      {
        _name: "CSidebarNavItem",
        name: "Tournaments",
        icon: "cil-notes",
        to: "/tournaments",
      },


      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Stakelist',
      //   icon: 'cil-notes',
      //   to: '/stakingCoin'
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Capture CSVDownload',
      //   icon: 'cil-notes',
      //   to: '/csvDownload'
      // },
      // {
      //   _name: 'CSidebarNavTitle',
      //   _children: ['NFT ']
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Card Details ',
      //   icon: 'cil-pencil',
      //   to: '/cardDetails'
      // },
    ],
  },
];
